import styled from '@mui/material/styles/styled'

export const StyledIconButtonAsLink = styled('div', {
  name: 'DirectBilling',
  slot: 'IconButtonAsLink',
  shouldForwardProp: prop => prop !== 'underline'
})<{ underline?: boolean }>(({ theme, underline = false }) => ({
  display: 'flex',
  cursor: 'pointer',
  height: '100%',
  color: theme.palette.custom.blue,

  '.MuiButtonBase-root::after': {
    height: underline ? '' : 0,
  }
}))
